import { render, staticRenderFns } from "./OnboardingAppoint.vue?vue&type=template&id=3a54ebd9&"
import script from "./OnboardingAppoint.vue?vue&type=script&lang=js&"
export * from "./OnboardingAppoint.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAppoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports